"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var layout_components_1 = require("../styled/layout-components");

exports.Trigger = styled_components_1.default(layout_components_1.RowCentered)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.TriggerTextContainer = styled_components_1.default(layout_components_1.DistributedRow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    padding: 7px 12px;\n    border-width: 1px;\n    background: white;\n    border-color: ", ";\n    border-radius: 3px;\n"], ["\n    width: 100%;\n    padding: 7px 12px;\n    border-width: 1px;\n    background: white;\n    border-color: ", ";\n    border-radius: 3px;\n"])), function (props) {
  return props.theme.colors.gray;
});
exports.TriggerText = styled_components_1.default(react_native_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 18px;\n    color: ", ";\n    background: white;\n    line-height: 30px;\n"], ["\n    font-size: 18px;\n    color: ", ";\n    background: white;\n    line-height: 30px;\n"])), function (props) {
  return props.theme.colors.title;
});
exports.OptionContainer = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 10px 8px;\n"], ["\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 10px 8px;\n"])));
exports.OptionText = styled_components_1.default(function (_a) {
  var selected = _a.selected,
      rest = __rest(_a, ["selected"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-left: 8px;\n    font-size: 14px;\n    line-height: 18px;\n    color: ", ";\n"], ["\n    margin-left: 8px;\n    font-size: 14px;\n    line-height: 18px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      selected = _a.selected;
  return selected ? theme.colors.system.success : theme.colors.title;
});
var maxWidth = 340;
exports.popupOptionsCustomStyles = {
  optionsContainer: {
    backgroundColor: 'white',
    padding: 13,
    borderRadius: 3,
    width: maxWidth,
    maxHeight: 420,
    overflowY: 'auto'
  },
  optionWrapper: {
    padding: 0
  },
  optionTouchable: {
    activeOpacity: 80
  }
};
exports.triggerCustomStyles = {
  triggerOuterWrapper: {
    flex: 1,
    width: maxWidth
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;